// Messaging service (Firebase wrapper)
export {
  requestPermission,
  getPermissionStatus,
  getToken,
  deleteToken,
  unregisterDeviceForRemoteMessages,
  onTokenRefresh,
  onForegroundMessage,
  setBackgroundMessageHandler,
  getInitialNotification,
  onNotificationOpenedApp,
  getDevicePlatform,
  AUTHORIZATION_STATUS,
} from "./messaging-service";
export type { AuthorizationStatus, RemoteMessage } from "./messaging-service";

// Notification payload types
export { NotificationDataSchema } from "./types";
export type { NotificationData, PermissionStatus, PushNotificationStatus } from "./types";

// Navigation
export { navigateToNotification } from "./navigate-to-notification";

// Device token API (plain client)
export { createDeviceTokenApi } from "./device-token-api";
export type { DeviceTokenApi, DeviceTokenApiOptions } from "./device-token-api";

// Device token React Query hook
export {
  useDeviceToken,
  STATUS_QUERY_KEY,
  PermissionDeniedError,
  RegistrationCancelledError,
  teardownDeviceToken,
} from "./use-device-token";
export type { UseDeviceTokenOptions } from "./use-device-token";
export { useHasActivePushDevice, ACTIVE_PUSH_DEVICE_QUERY_KEY } from "./use-has-active-push-device";
export type { UseHasActivePushDeviceOptions } from "./use-has-active-push-device";

// Push notification lifecycle hook
export { usePushNotifications } from "./use-push-notifications";
export type { UsePushNotificationsOptions } from "./use-push-notifications";

// Notification settings UI
export {
  NotificationPreferencesForm,
  type NotificationPreferencesFormProps,
  type NotificationPreferencesFormSite,
  type CameraNotificationPreference,
  type PushAvailability,
} from "./components/NotificationPreferencesForm/NotificationPreferencesForm";
export {
  NotificationPushUnavailableBanner,
  type NotificationPushUnavailableBannerProps,
} from "./components/NotificationPushUnavailableBanner/NotificationPushUnavailableBanner";
export {
  NotificationAccessBanner,
  type NotificationAccessBannerProps,
  type NotificationAccessBannerReason,
} from "./components/NotificationAccessBanner/NotificationAccessBanner";
export {
  NotificationPushSwitch,
  type NotificationPushSwitchProps,
  type PushSwitchControlProps,
} from "./components/NotificationPushSwitch/NotificationPushSwitch";
export {
  type NotificationChannel,
  type NotificationCategory,
  type NotificationChannelPreferences,
  type NotificationCategoryPreferences,
} from "./components/NotificationPreferenceGroup/NotificationPreferenceGroup";
export { NO_NOTIFICATION_CHANNELS, DEFAULT_NOTIFICATION_CATEGORY_PREFERENCES } from "../preferences";

// Notification settings hooks
export { useNotificationPreferences, type NotificationPreferencesState } from "./hooks/useNotificationPreferences";
export { useContactPhoneNumber, type ContactPhoneNumberState } from "./hooks/useContactPhoneNumber";
export {
  usePushNotificationSwitch,
  type UsePushNotificationSwitchOptions,
  type PushNotificationSwitchState,
  type StoredDeviceToken,
} from "./hooks/usePushNotificationSwitch";
